const FormatDecimalOdds = {
    title: 'Example JSON for formatDecimalOdds function',
    expectedOutput: '1.20',
    initialDisplayedCode: `{
    "rawOdds": 1200 
}`,
};

export default FormatDecimalOdds;
